import { ReportsFilterOption } from '@dataTypes/reports.type'

/** Default filter chips shown on every report workspace toolbar. */
export const REPORTS_DEFAULT_FILTERS: ReportsFilterOption[] = [
  { id: 'period-category', label: 'Latest Data' },
  { id: 'period-preset', label: 'This Month' },
  { id: 'provider-filter', label: 'All Providers' },
]

/** Shown in snapshot mode: time-of-day window for the as-of date (e.g. 6:00–5:00). */
export const SNAPSHOT_TIME_FILTER_OPTION: ReportsFilterOption = {
  id: 'snapshot-time',
  label: 'Time window',
}
